import _extends from "@babel/runtime-corejs3/helpers/extends";

var _this = this;

import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";

/**
 * holds the components to show up the 'library asset select' window, having controls for listing and filtering assets
 */
import React, { useEffect, useState } from 'react';
import { getContext } from 'react-recompose';
import PropTypes from 'prop-types';
import * as _ from "../../../util/lodash";
import Layout from "../../core/layout";
import Panel from "../panel";
import TextMenu from "../../core/text-menu";
import Paging from "../../core/paging";
import LoadingState from "../loading-state";
import AssetList from "./asset-list";
import PexelsAssetList from "./pexels-asset-list";
import { positions, sizes, widths, textAlignments, directions, documentTypes, sortOptions, orderTypes } from "../../../enums";
import BigSearch from "../big-search";
import * as FileUtils from "../../core/asset-uploader/file-utils";
/**
 * filter scope values
 */

var FILTER_SCOPE = {
  EXPERIENCE: 'experience',
  LIBRARY: 'library',
  PEXELS: 'pexels'
};
var SEARCH_DELAY = 500;
var ITEMS_PER_PAGE = 50;
/**
 * Prepares the tabs menu content for the different document types
 */

var scopeTabs = _.memoize(function (currentDocumentTypes, containerRef) {
  var tabs = [{
    text: 'library',
    value: FILTER_SCOPE.LIBRARY
  }];

  if (_includesInstanceProperty(currentDocumentTypes).call(currentDocumentTypes, documentTypes.IMAGE)) {
    tabs.push({
      text: 'pexels',
      value: FILTER_SCOPE.PEXELS
    });
  }

  if (containerRef.length > 0) {
    tabs.push({
      text: 'experience',
      value: FILTER_SCOPE.EXPERIENCE
    });
  }

  return tabs;
}, function (currentDocumentTypes, containerRef) {
  return "cache-" + _JSON$stringify(currentDocumentTypes) + "-" + containerRef;
});
/**
 * function will load the asset list using the passed params object
 * @param params - params to be sent for filtering the asset list
 * @param onDataReceived - function to be called when data is received
 * @param onError - function to be called when error happens
 */


var loadAssets = function loadAssets(params, onDataReceived, onError, CKConfig) {
  var xhr = new XMLHttpRequest();
  var fd = new FormData();
  var isPexelsSelection = params.scope === FILTER_SCOPE.PEXELS;

  if (params && typeof params === 'object') {
    for (var key in params) {
      fd.append(key, params[key]);
    }
  }

  var assetUrl = isPexelsSelection ? CKConfig.assetUrls.assetPexelsListUrl : CKConfig.assetUrls.assetListUrl;
  xhr.open(CKConfig.assetUploader.postMethod, assetUrl, true);
  xhr.addEventListener('load', function (evt) {
    if (evt.currentTarget.readyState === 4 && evt.currentTarget.status === 200) {
      var response = JSON.parse(evt.target.responseText);

      if (response && response.status && response.status === 'ok') {
        onDataReceived.call(_this, response.content, response.page + 1, response.count);
      } else {
        onError.call(_this, response.errorMessage);
      }
    } else {
      onError.call(_this, 'IO error loading meta data');
    }
  }, false);
  xhr.addEventListener('error', function (evt) {
    onError.call(_this, evt.currentTarget.responseText);
  }, false);
  xhr.send(fd);
};
/**
 * Will build out the necessary params we need to send for filtering the assets list. Will set the state when assets are loaded. Will also set the 'isFetching' accordingly.
 * @param currentFilters -  filters object having 'scope' and 'search' text.
 * @param librarySelectProps -  required state and props variables from LibrarySelect.
 * @param page - do a request within the provided page.
 */


var filterAssets = function filterAssets(currentFilters, librarySelectProps, page) {
  var fileType = FileUtils.getFileTypeFromDocumentType(librarySelectProps.documentTypes);
  var paginationParams = {
    offset: (page - 1) * ITEMS_PER_PAGE,
    max: ITEMS_PER_PAGE
  };

  var params = _extends({
    containerRef_filter: currentFilters.scope === FILTER_SCOPE.LIBRARY && librarySelectProps.libraryRef ? librarySelectProps.libraryRef : librarySelectProps.containerRef || '',
    typeRef_filter: fileType,
    libAndContainer: false,
    sort: _sortInstanceProperty(librarySelectProps),
    order: librarySelectProps.order,
    search: currentFilters.search.commaSeparated || '',
    scope: currentFilters.scope
  }, paginationParams); // Pexels endpoint requires pretty different params in payload


  if (currentFilters.scope === FILTER_SCOPE.PEXELS) {
    params = _extends({
      query: currentFilters.search.original || '',
      scope: currentFilters.scope
    }, paginationParams);
  } // load in the initial list of assets


  librarySelectProps.setAssets(_extends({}, librarySelectProps.assets, {
    isFetching: true,
    currentPage: page,
    list: []
  }));
  loadAssets(params, function (assetList, apiPage, itemsTotal) {
    librarySelectProps.setAssets({
      itemsTotal: itemsTotal,
      isFetching: false,
      currentPage: apiPage,
      list: assetList
    });
  }, function () {
    librarySelectProps.setAssets(_extends({}, librarySelectProps.assets, {
      itemsTotal: 0,
      isFetching: false,
      currentPage: 0
    }));
  }, librarySelectProps.CKConfig);
};
/**
 * Debounced search function. Also it keeps a preparation logic for the search query (used in old assets search)
 */


var debouncedFilterAssets = _.debounce(function (newActiveSearchString, librarySelectProps) {
  var _context;

  var commaSeparated = _filterInstanceProperty(_context = newActiveSearchString.split(/,+\ *|\ +/)).call(_context, function (term) {
    return term !== '';
  }).join(',');

  var _filters = _Object$assign({}, librarySelectProps.filters, {
    search: {
      commaSeparated: commaSeparated,
      original: newActiveSearchString
    }
  });

  librarySelectProps.setFilters(_filters);
  filterAssets(_filters, librarySelectProps, 1);
}, SEARCH_DELAY);
/**
 * Asset selector component, displaying filter controls and list of assets in a Modal window
 */


var LibrarySelect = function LibrarySelect(props) {
  var _context2, _context3;

  var _useState = useState({
    isFetching: false,
    list: [],
    currentPage: 1,
    itemsTotal: 0
  }),
      assets = _useState[0],
      setAssets = _useState[1];

  var _useState2 = useState({
    scope: FILTER_SCOPE.LIBRARY,
    search: {
      commaSeparated: '',
      original: ''
    }
  }),
      filters = _useState2[0],
      setFilters = _useState2[1]; // gather required state and props variables to be passed to the outter memo functions


  var librarySelectProps = _extends({
    assets: assets,
    setAssets: setAssets,
    filters: filters,
    setFilters: setFilters
  }, _.pick(props, ['documentTypes', 'libraryRef', 'containerRef', 'sort', 'order', 'CKConfig']));

  var handleScopeChange = function handleScopeChange(e, _ref) {
    var value = _ref.value;

    var _filters = _Object$assign({}, filters, {
      scope: value
    });

    setFilters(_filters);
    filterAssets(_filters, librarySelectProps, 1);
  };

  var handlePageChange = function handlePageChange(e, _ref2) {
    var value = _ref2.value;

    if (value) {
      filterAssets(filters, librarySelectProps, value);
    } else {
      setAssets(_extends({}, assets, {
        currentPage: null
      }));
    }
  };

  var handleActiveSearchChange = function handleActiveSearchChange(e, _ref3) {
    var value = _ref3.value;
    debouncedFilterAssets(value, librarySelectProps);
  }; // Initial search of assets on load


  useEffect(function () {
    filterAssets(filters, librarySelectProps, 1);
  }, []);
  var onAssetSelected = props.onAssetSelected,
      containerRef = props.containerRef,
      isInModal = props.isInModal,
      CKConfig = props.CKConfig,
      displayFilterScope = props.displayFilterScope,
      onFileSelected = props.onFileSelected;
  return /*#__PURE__*/React.createElement(Panel, {
    hasBorder: false,
    padding: {
      horizontal: sizes.X1,
      vertical: sizes.X1
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "library-select"
  }, assets.isFetching ? /*#__PURE__*/React.createElement("div", {
    className: "library-select-loading"
  }, /*#__PURE__*/React.createElement(Layout, {
    isFluidHeight: true,
    columnStyles: {
      verticalAlign: positions.verticalAlign.MIDDLE
    }
  }, /*#__PURE__*/React.createElement(LoadingState, {
    header: "Loading",
    height: sizes.L,
    spinnerSize: sizes.M
  }))) : null, /*#__PURE__*/React.createElement(Layout, {
    columnStyles: {
      textAlign: textAlignments.LEFT
    },
    borders: directions.H
  }, /*#__PURE__*/React.createElement(Layout.Row, {
    columns: widths.THREE,
    style: {
      padding: '0 0 10px 0'
    }
  }, /*#__PURE__*/React.createElement(Layout.Column, {
    columnWidth: isInModal ? widths.FIVE : widths.SIX,
    textAlign: textAlignments.LEFT,
    verticalAlign: positions.verticalAlign.MIDDLE
  }, displayFilterScope ? /*#__PURE__*/React.createElement(TextMenu, {
    isInverted: props.isInverted,
    items: scopeTabs(props.documentTypes, containerRef),
    activeValue: filters.scope,
    "float": positions.LEFT,
    onItemClick: handleScopeChange,
    size: sizes.X4
  }) : null), /*#__PURE__*/React.createElement(Layout.Column, {
    columnWidth: widths.TEN,
    textAlign: textAlignments.RIGHT,
    verticalAlign: positions.verticalAlign.MIDDLE
  }, /*#__PURE__*/React.createElement(BigSearch, {
    onChange: handleActiveSearchChange,
    placeholder: filters.scope === FILTER_SCOPE.PEXELS ? 'Search image...' : 'Search assets...'
  }))), /*#__PURE__*/React.createElement(Layout.Row, {
    style: {
      padding: '5px 0px 10px 0px'
    }
  }, filters.scope === FILTER_SCOPE.PEXELS ? /*#__PURE__*/React.createElement(PexelsAssetList, {
    list: assets.list,
    onAssetSelected: onAssetSelected,
    isCompact: isInModal,
    searchQuery: _trimInstanceProperty(_context2 = filters.search.original).call(_context2)
  }) : /*#__PURE__*/React.createElement(AssetList, {
    list: assets.list,
    onAssetSelected: onAssetSelected,
    isCompact: isInModal,
    userTimeZone: CKConfig.userTimeZone,
    isExperienceScope: filters.scope === FILTER_SCOPE.EXPERIENCE,
    searchQuery: _trimInstanceProperty(_context3 = filters.search.original).call(_context3),
    onFileSelected: onFileSelected
  })), /*#__PURE__*/React.createElement(Layout.Row, {
    style: {
      padding: '10px 0px 5px 0px'
    }
  }, /*#__PURE__*/React.createElement(Paging, {
    itemsTotal: assets.itemsTotal,
    currentPage: assets.currentPage,
    itemsPerPage: ITEMS_PER_PAGE,
    isDisabled: false,
    onChange: handlePageChange
  })))));
};

LibrarySelect.propTypes = {
  libraryRef: PropTypes.string,
  containerRef: PropTypes.string,
  onAssetSelected: PropTypes.func.isRequired,
  documentTypes: PropTypes.array,
  sort: PropTypes.string,
  order: PropTypes.oneOf(orderTypes.ALL),
  isInModal: PropTypes.bool,
  CKConfig: PropTypes.object,
  displayFilterScope: PropTypes.bool,
  onFileSelected: PropTypes.func.isRequired
};
LibrarySelect.defaultProps = {
  libraryRef: '',
  containerRef: '',
  documentTypes: [documentTypes],
  sort: sortOptions.LAST_UPDATED,
  order: orderTypes.DESC,
  isInModal: false,
  CKConfig: {},
  displayFilterScope: true
};
export default getContext({
  isInverted: PropTypes.bool
})(LibrarySelect);
//# sourceMappingURL=library-select.js.map